import { useState } from "react";
import styled from "styled-components";
import { mobile } from "../../responsive";
import swal from "sweetalert";
import apiClient from "./../../api/client";
import useAuth from "./../../auth/useAuth";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { logIn } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await apiClient.post("/admin/adminregister", {
      name,
      email,
      password,
    });
    if (!result.ok) {
      swal("Error Retry!");
    } else {
      logIn(result.data.token);
      swal("Registered Successfully");
    }
  };
  return (
    <Container>
      <Wrapper>
        <Title>CREATE AN ACCOUNT</Title>
        <Form>
          <Input
            placeholder="Name"
            name="name"
            onChange={(e) => setName(e.target.value)}
          />
          <Input
            placeholder="Email Address"
            name="email"
            onChange={(e) => setEmail(e.target.value)}
          />

          <Input
            placeholder="Password"
            name="password"
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button onClick={handleSubmit}>CREATE</Button>
        </Form>
      </Wrapper>
    </Container>
  );
};

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: grey;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  ${mobile({ marginTop: "50px" })}
`;

const Wrapper = styled.div`
  width: 45%;
  padding: 20px;
  background-color: white;
  ${mobile({ width: "75%" })}
  border-radius: 10px;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 500;
`;

const Form = styled.form`
  display: flex;
  flex-wrap: wrap;
`;

const Input = styled.input`
  flex: 1;
  min-width: 40%;
  margin: 20px 10px 0px 0px;
  padding: 10px;
`;

const Button = styled.button`
  width: 50%;
  border: none;
  padding: 15px 20px;
  background-color: teal;
  color: white;
  cursor: pointer;
  border-radius: 15px;
  margin: 0 auto;
  ${mobile({ width: "50%", marginBottom: "20px" })}
`;

const Link = styled.a`
  font-size: 17px;
  text-decoration: underline;
  cursor: pointer;
  text-align: center;
  margin-top: 40px;
  color: black;
  ${mobile({ margin: "10px auto" })}
`;

export default Register;
